import { Icon } from '@components/old-rolex-ui'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import React from 'react'

type FooterProps = {
  variant?: 'rolex' | 'rcpo'
}

const Footer: React.FC<FooterProps> = ({ variant = 'rolex' }) => {
  const { t } = useTranslation('rolex')
  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

  return (
    <div
      className={cn(
        'w-full',
        variant === 'rcpo' ? 'bg-black' : 'bg-gradient-to-r from-rolexGreenDark to-rolexPrimary',
      )}
    >
      <div className="flex h-32 items-center justify-center md:h-40">
        <img src="/images/rolex-crown.png" alt="Rolex logo" className="h-8 w-8 md:h-10 md:w-10" />
      </div>
      <div className="h-[1px] w-full bg-white/20" />
      <div className="flex h-[60px] items-center justify-center md:h-20">
        <button
          className="flex flex-col items-center border-none text-white outline-none"
          onClick={() => scrollToTop()}
        >
          <Icon icon="rolex-back-to-top-arrow" />
          <Text variant="legend16" className="-mt-1 mb-1">
            {t('backToTop')}
          </Text>
        </button>
      </div>
    </div>
  )
}

export default Footer
